/*
 *
 * CleverTap events name
 *
 */

export const LOGIN_SUCCESSFULL = 'LOGIN_SUCCESSFULL';
export const LOGIN_WITH_PASSWORD_INITIATED = 'LOGIN_WITH_PASSWORD_INITIATED';
export const LOGIN_WITH_MOTP_INITIATED = 'LOGIN_WITH_MOTP_INITIATED';
export const LOGIN_WITH_EOTP_INITIATED = 'LOGIN_WITH_EOTP_INITIATED';
export const OTP_VERIFICATION_ERROR = 'OTP_VERIFICATION_ERROR';
export const OTP_VERIFIACTION = 'OTP_VERIFIACTION';

// on Password Reset Proceed Clicked
export const PASSWORD_RESET_PROCEED_CLICKED = 'PASSWORD_RESET_PROCEED_CLICKED';

// on Update Mobile  details submitted
export const UPDATE_MOBILE_DETAILS_SUBMITTED = 'UPDATE_MOBILE_DETAILS_SUBMITTED';

// mobile update initiated when user clicks on update mobile link
export const MOBILE_UPDATE_INITIATED = 'MOBILE_UPDATE_INITIATED';

// on pass set render
export const PASSWORD_SET_FLOW_INITIATED = 'PASSWORD_SET_FLOW_INITIATED';

// on password successfully set
export const PASSWORD_SET_SUCCESSFULLY = 'PASSWORD_SET_SUCCESSFULLY';

//
export const CREATE_SWITCHED_TO_LOGIN = 'CREATE_SWITCHED_TO_LOGIN';

// 
export const LOGIN_FLOW_INITIATED = 'LOGIN_FLOW_INITIATED';

export const EMAIL_FILLED = 'EMAIL_FILLED';

export const CREATE_ACCOUNT_NEXT_CTA_ERROR = 'CREATE_ACCOUNT_NEXT_CTA_ERROR';

export const CREATE_ACCOUNT_INITIATED = 'CREATE_ACCOUNT_INITIATED';

export const CREATE_ACCOUNT_SUCCESSFULL = 'CREATE_ACCOUNT_SUCCESSFULL';

// when password expiry page is loaded;
export const PASSWORD_EXPIRY_PAGE_LOADED = 'PASSWORD_EXPIRY_PAGE_LOADED';

export const LOGOUT = 'LOGOUT';

//Trigger when, user clicks on the next button
export const USER_ACCOUNT_DETAILS_SUBMITTED = 'USER_ACCOUNT_DETAILS_SUBMITTED';

// on otp resend clicked
export const OTP_RESEND_CLICKED = 'OTP_RESEND_CLICKED';

// on successfull otp verification
export const OTP_VERIFIED = 'OTP_VERIFIED';

// on verify otp submit button clicked
export const OTP_VERIFY_BUTTON_CLICKED = 'OTP_VERIFY_BUTTON_CLICKED';

// on form submit
export const NAME_FILLED = 'NAME_FILLED';

// on focus out
export const MOBILE_FILLED = 'MOBILE_FILLED';

// on form submit
export const PASSWORD_FILLED = 'PASSWORD_FILLED';

// on skip email otp link click 
export const SKIP_OTP_CLICKED = 'SKIP_OTP_CLICKED';

// on set name screen
export const NAME_SET_FLOW_INITIATED = 'NAME_SET_FLOW_INITIATED';

// on set name success
export const NAME_SET_SUCCESSFULLY = 'NAME_SET_SUCCESSFULLY';

//on selecting a mid on mid selector screen
export const LOGIN_INTO_BUSINESS = "Login into Business";

//on CTA MID selector screen
export const MID_SCREEN_CLICKED = "MID selector screen clicked";